import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
    vendaPesquisa: {
      status: undefined,
      dataVendaInicio: undefined,
      dataVendaFim: undefined,
      imovel: {
        idNaImobiliaria: undefined
      },
      cliente: {
        nome: undefined
      },
      pagina: 0
    },
    vendaSelecionada: {
      id: 0,
      valor: 0,
      comissao: 0,
      valorComissao: 0,
      usuario: { id: 0 },
      imovel:{ id: 0, endereco: '',
        bairro: { id: 0, nome: '' },
        cidade: { id: 0, nome: '' }, 
      },
      cliente: { id: 0, nome: '' },
      comissoes: [],
      copiaRG: false,
      copiaCPF: false,
      comprovanteDeRenda: false,
      comprovanteDeResidencia: false,
      comprovanteDeTransferencia: false,
      certidaoDeCasamento: false
    },
    listaVendas:[],
    formularios: [],
    logs: [],
    usuariosDisponiveis: [],
    clientesDisponiveis: [],
    imoveisDisponiveis: [],

    labelQuantidade: ''
}

const mutations = {
  novaVenda(state) {
    state.vendaSelecionada = {
      id: 0,
      valor: 0,
      comissao: 0,
      valorComissao: 0,
      usuario: { id: 0, nome: '' },
      imovel:{ id: 0, endereco: '',
        bairro: { id: 0, nome: '' },
        cidade: { id: 0, nome: '' }, 
      },
      cliente: { id: 0, nome: '' },
      comissoes: [],
      copiaRG: false,
      copiaCPF: false,
      comprovanteDeRenda: false,
      comprovanteDeResidencia: false,
      comprovanteDeTransferencia: false,
      certidaoDeCasamento: false
    };
    state.logs = [];
    state.formularios = [];
    state.usuariosDisponiveis = [];
    state.clientesDisponiveis = [];
    state.imoveisDisponiveis = [];
  },
  limparVendaPesquisa(state) {
    state.vendaPesquisa = {
      status: undefined,
      dataVendaInicio: undefined,
      dataVendaFim: undefined,
      imovel: {
        idNaImobiliaria: undefined
      },
      cliente: {
        nome: undefined
      },
      pagina: 0
    }
  },
  limparVendasListadas(state) {
    state.listaVendas = [];
  },
  atualizarListaVendas(state, payload) {
    if(state.vendaPesquisa.pagina == 0) {
      state.listaVendas = payload.lista;
    } else {
      state.listaVendas.push(...payload.lista);
    }
    state.labelQuantidade = payload.quantidade + (payload.quantidade == 1 ? " contrato encontrado" : " contratos encontrados");
  },
  atualizarVendaSelecionada(state, payload) {
    state.vendaSelecionada = payload;
    state.usuariosDisponiveis = [payload.usuario];
    state.clientesDisponiveis = [payload.cliente];
    state.imoveisDisponiveis = [payload.imovel];
  },
  atualizarClienteVendaSelecionada(state, payload) {
    state.vendaSelecionada.cliente = payload;
    state.clientesDisponiveis = [payload];
  },
  atualizarUsuariosDisponiveis(state, payload) {
    state.usuariosDisponiveis = payload
  },
  atualizarClientesDisponiveis(state, payload) {
    state.clientesDisponiveis = payload
  },
  atualizarImoveisDisponiveis(state, payload) {
    const imoveisDisponiveis = payload.filter(imovel => imovel.status === 'DISPONIVEL');
    state.imoveisDisponiveis = [...imoveisDisponiveis]
  },
  atualizarFormularios(state, payload) {
    state.formularios = payload;
  },
  atualizarLogs(state, payload) {
    state.logs = payload;
  },
  atualizarArquivos(state, payload) {
    state.vendaSelecionada.diretorios = payload;
  },
}

const actions = {
  //VENDA  
  novaVenda(context) {
    context.commit('novaVenda');
  },
  limparVendaPesquisa(context) {
    context.commit("limparVendaPesquisa");
  },
  limparVendasListadas(context) {
    context.commit("limparVendasListadas");
  },
  listarVendas(context, payload) {
    return axios.post(URLS.VENDAS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaVendas', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarVendas', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarVenda(context, payload) {
    return axios.post(URLS.VENDAS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarVenda(context, payload) {
    return axios.post(URLS.VENDAS_GRAVAR, context.state.vendaSelecionada)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerVenda(context, payload) {
    return axios.post(URLS.VENDAS_REMOVER, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.dispatch('novaVenda');
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  aprovarVenda(context, payload) {
    return axios.post(URLS.VENDAS_APROVAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('aprovarVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  desaprovarVenda(context) {
    let payload = { id: context.state.vendaSelecionada.id };
    return axios.post(URLS.VENDAS_DESAPROVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('desaprovarVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  cancelarVenda(context) {
    let payload = { id: context.state.vendaSelecionada.id };
    return axios.post(URLS.VENDAS_CANCELAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  restaurarVenda(context) {
    let payload = { id: context.state.vendaSelecionada.id };
    return axios.post(URLS.RESTAURAR_VENDA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('restaurarVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarClienteNovoVenda(context, payload) {
    return axios.post(URLS.CLIENTES_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClienteVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarClienteNovoVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //RECUPERAR LISTAS
  listarUsuarios(context, payload) {
    return axios.post(URLS.USUARIOS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarUsuariosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarUsuarios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarUsuariosDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClientesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarClientes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarClientesDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarImoveis(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveisDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarImoveis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarImoveisDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //FORMULÁRIOS
  criarDiretorioVenda(context, payload) {
    return axios.post(URLS.FORMULARIOS_CRIAR_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('criarDiretorioVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  recuperarFormularios(context, payload) {
    return axios.post(URLS.FORMULARIOS_RECUPERAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarFormularios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  recuperarPerguntasFormulario(context, payload) {
    return axios.post(URLS.FORMULARIOS_RECUPERAR_PERGUNTAS, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarPerguntasFormulario', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gerarFormularioVenda(context, payload) {
    return axios.post(URLS.FORMULARIOS_GERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarFormularioVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerDiretorioVenda(context, payload) {
    return axios.post(URLS.FORMULARIOS_REMOVER_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerDiretorio', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  selecionarDiretorioVenda(context, payload) {
    return axios.post(URLS.FORMULARIOS_SELECIONAR_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('selecionarDiretorioVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //LOGS
  recuperarLogs(context, payload) {
    return axios.post(URLS.LOGGER_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarLogs', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarLogs', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //COMISSÕES
  pagarComissaoCorretor(context, payload) {
    return axios.post(URLS.VENDAS_PAGAR_PAGAMENTO_COMISSAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('pagarComissaoCorretor', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  pagarComissaoCompleta(context, payload) {
    return axios.post(URLS.VENDAS_PAGAR_COMISSAO_COMPLETA, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('pagarComissaoCompleta', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  adicionarPagamentoComissao(context, payload) {
    return axios.post(URLS.VENDAS_GRAVAR_PAGAMENTO_COMISSAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('adicionarPagamentoComissao', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  cancelarPagamentoComissao(context, payload) {
    return axios.post(URLS.VENDAS_CANCELAR_PAGAMENTO_COMISSAO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarPagamentoComissao', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerPagamentoComissao(context, payload) {
    return axios.post(URLS.VENDAS_REMOVER_PAGAMENTO_COMISSAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerPagamentoComissao', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gerarReciboComissaoPagos(context, payload) {
    return axios.post(URLS.FORMULARIOS_GERAR_RECIBO_COMISSAO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarReciboComissaoPagos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gerarReciboComissaoUnico(context, payload) {
    return axios.post(URLS.FORMULARIOS_GERAR_RECIBO_COMISSAO_UNICO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarReciboComissaoUnico', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  //ARQUIVOS
  criarDiretorioArquivoVenda(context, payload) {
    return axios.post(URLS.ARQUIVOS_CRIAR_DIRETORIO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarArquivos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('criarDiretorioArquivoVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  removerDiretorioArquivos(context, payload) {
    return axios.post(URLS.ARQUIVOS_REMOVER_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarArquivos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerDiretorioArquivos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  selecionarDiretorioArquivoVenda(context, payload) {
    return axios.post(URLS.ARQUIVOS_SELECIONAR_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarArquivos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('selecionarDiretorioArquivoVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  uploadArquivoVenda(context, payload) {
    return axios.post(URLS.ARQUIVOS_UPLOAD, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('uploadArquivoVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerArquivo(context, payload) {
    return axios.post(URLS.ARQUIVOS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerArquivo', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  //OBSERVAÇÕES
  recuperarObservacaoVenda(context, payload) {
    return axios.post(URLS.OBSERVACOES_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarObservacaoVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarObservacaoVenda(context, payload) {
    return axios.post(URLS.OBSERVACOES_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarObservacaoVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerObservacao(context, payload) {
    return axios.post(URLS.OBSERVACOES_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerObservacao', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  verificarAprovacaoVenda(context, payload) {
    return axios.post(URLS.VENDAS_VERIFICAR_APROVACAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarVendaSelecionada', response.data.item);
          return response.data;
        case "FALHA":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('verificarAprovacaoVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
}

export default {
  state,
  mutations,
  actions
}